/* src/app/app.component.scss */
lib-header {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
}
/*# sourceMappingURL=app.component.css.map */
